import { createStore, setStateHelper } from "@neonumy/ant-design";
import { StoreApi, UseBoundStore } from "zustand";

const initialState = {
  paymentWaitingValue: 0,
  invoicedValue: 0,
  paymentsValue: 0,
  budgetNotInvoicedValue: 0,
  priorityTasksInfo: undefined,
};

interface DashboardStore {
  resetStore: () => void;
  invoicedValue: number;
  paymentWaitingValue: number;
  budgetNotInvoicedValue: number;
  paymentsValue: number;
  priorityTasksInfo: Partial<SaleDocumentFilter> | undefined;
  setPaymentWaitingValue: (paymentWaitingValue: number) => void;
  setInvoicedValue: (invoicedValue: number) => void;
  setPaymentsValue: (paymentsValue: number) => void;
  setBudgetNotInvoicedValue: (budgetNotInvoicedValue: number) => void;
  setPriorityTasksInfo: (priorityTasksInfo: Partial<SaleDocumentFilter>) => void;
}

const useDashboardStore: UseBoundStore<StoreApi<DashboardStore>> = createStore<DashboardStore>(
  (set: (fn: (draft: DashboardStore) => void) => void) => ({
    ...initialState,
    resetStore: () => {
      set(() => ({
        ...initialState,
      }));
    },
    setPaymentWaitingValue: (paymentWaitingValue: number) => {
      setStateHelper("paymentWaitingValue", paymentWaitingValue, set);
    },
    setInvoicedValue: (invoicedValue: number) => {
      setStateHelper("invoicedValue", invoicedValue, set);
    },
    setPaymentsValue: (paymentsValue: number) => {
      setStateHelper("paymentsValue", paymentsValue, set);
    },
    setBudgetNotInvoicedValue: (budgetNotInvoicedValue: number) => {
      setStateHelper("budgetNotInvoicedValue", budgetNotInvoicedValue, set);
    },
    setPriorityTasksInfo: (priorityTasksInfo: Partial<SaleDocumentFilter>) => {
      setStateHelper("priorityTasksInfo", priorityTasksInfo, set);
    },
  }),
);

export default useDashboardStore;
